export { default as MedBarChart } from './MedBarChart';
export type { BarChartGroup } from './MedBarChart';
